<template>
  <div
      class="d-flex align-items-center justify-content-between"
      style="padding: 0.5rem 0px 0px; height: 4.5rem"
  >
    <div class="d-flex align-items-center cursor-pointer" @click="$router.push('/welcome')">
      <img
          style="width: 14.3rem; height: 100%"
          src="../../assets/images/dashboard/logo3.svg"
          alt=""
      />
      <div style="color: #fff; font-size: 30px; font-weight: 600;margin-left:10px">
        {{
          $t(
              "overview_static.nash_intelligent_iiot_after_market_management_system"
          )
        }}
      </div>
    </div>
    <div
        class="d-flex justify-content-around align-content-center align-items-center"
        style=" font-size: 0.9375rem; font-weight: 500"
    >
      <!-- <div style="cursor: pointer" @click="skipPage('repair-request/list')">
         {{ $t('overview_dynamic["主页"]') }}
       </div>-->
      <div class="ms-1 d-flex align-content-center align-items-center">
        <div class="me-1 fs-20" style="font-weight: 700">{{ timeData }}</div>
        <div style="text-align: center">
          <div>{{ yearData }}</div>
          <div>{{ weekData }}</div>
        </div>
      </div>
      <div class="ms-1 header-item d-sm-flex cursor-pointer">
        <div
            class="d-flex align-items-center flex-column justify-content-center"
            style="color: white; width: 42px"
        >
            <span
                :class="[
                'lang',
                language == 'ch' && 'current',
                language == 'ch' && 'fs-5',
              ]"
                @click="changeLang('ch')"
            >
              CN
            </span>
          <span
              :class="[
                'lang',
                language == 'en' && 'current',
                language == 'en' && 'fs-5',
              ]"
              @click="changeLang('en')"
          >
              EN
            </span>
        </div>
      </div>
      <div>
        <div>
          <i
              :class="[icon]"
              id="fullscreen"
              :style="{
                color: '#ffffff',
                cursor: 'pointer',
                fontSize: '32px',
              }"
              @click="toggleFullScreen()"
          ></i>
        </div>
      </div>
      <div class="dropdown">
        <button
            type="button"
            class="btn p-0"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="d-flex align-items-center">
              <span class="text-start ms-xl-2">
                <span
                    class="d-none d-xl-block ms-1 fs-12 text-white user-name-sub-text"
                >{{ user.org.name || "" }}</span
                >
              </span>
            </span>
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <!--<b-link class="dropdown-item" href="###" @click="skipPage('repair-request/list')"
              ><i
                class="mdi mdi-logout text-muted fs-16 align-middle me-1"
              ></i>
              <span class="align-middle" data-key="t-logout">主页</span>
            </b-link>-->
          <b-link class="dropdown-item" href="###" @click="logout"
          ><i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
            <span class="align-middle" data-key="t-logout">{{
                $t("page.logout")
              }}</span>
          </b-link>
          <form
              id="frm_logout"
              method="post"
              action=""
              style="display: none"
          ></form>
        </div>
      </div>
      <div class="go_out ms-2 me-4">
        <div class="back_home m_b5" @click="skipPageHome('repair-request/list')">
          <img :src="imageLists.back_home" alt="" />
        </div>
        <div class="logout" @click="logout()">
          <img :src="imageLists.logout" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { API_SVC_HOST } from "@/config/common";
export default {
  name: "home",
  data() {
    return {
      imageLists: {
        nash_logo: require("../../assets/Nash-white.png"),
        llot_logo: require("../../assets/llot-logo.svg"),
        back_home: require("../../assets/icon-font/Homepage-icon.svg"),
        logout: require("../../assets/icon-font/logout-icon.svg"),
      },
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      language: "ch",
    };
  },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    pathType() {
      return localStorage.getItem("pathType") || "dashboard";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
    pathId() {
      return localStorage.getItem("pathId") || 0;
    },
  },
  watch:{
    fullscreen:{
      handler(val){
        localStorage.setItem('fullscreen',val)
      },
      immediate: true,
    }
  },
  methods: {
    moment,
    //全屏
    fullele() {
      return (
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement ||
          null
      );
    },
    skipPage(path) {
      this.$router.push("/" + path);
    },
    skipPageHome(path) {
      let path_ ="/" + path
      // 云图权限问题  home跳转根据权限跳转（排除客户角色不变）
      // if(JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type!='customer'){
      //   path_ = localStorage.getItem("toHomePath")
      // }
      this.$router.push( path_ );
    },
    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;
      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      const element = ele || document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("app")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      this.$i18n.locale = lang;

      window.location.reload();
    },
    logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
  },
  mounted() {
    this.fullscreen= this.isFullScreen()

    let that = this;
    window.addEventListener("resize", () => {
      if (!that.isFullScreen()) {
        // 非全屏状态
        //业务逻辑
        this.fullscreen = false;
      }
    });

    this.language = localStorage.getItem("language") || "ch";
    this.timmer = setInterval(() => {
      this.timeData = this.moment().format("HH:mm:ss");
      this.yearData = this.moment().format("YYYY-M-D");
      this.weekData = [
        this.$t('overview_static.common["星期日"]'),
        this.$t('overview_static.common["星期一"]'),
        this.$t('overview_static.common["星期二"]'),
        this.$t('overview_static.common["星期三"]'),
        this.$t('overview_static.common["星期四"]'),
        this.$t('overview_static.common["星期五"]'),
        this.$t('overview_static.common["星期六"]'),
      ][this.moment().weekday()];
    }, 1000);
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除定时器
    }
  },
};

</script>
<style lang="scss">
.go_out {
  .back_home,
  .logout {
    width: 100%;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 15px;
    }
  }
}
</style>

